import useCommonStore from 'www/vue_components/common/TheFilters/doctors/stores/useCommonStore'
import useFiltersStore from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore'

function getFiltersUrl() {
  const pathname = generatePathname()
  const search = generateSearch()

  if (search) {
    return `${pathname}?${search}`
  }

  return pathname
}

function generatePathname() {
  const commonStore = useCommonStore()
  const filtersStore = useFiltersStore()

  let path = commonStore.url.doctorList

  path = path.replace('speciality-name', filtersStore.filters.speciality.translit)

  if (filtersStore.filters.visitLocation === 'online') {
    path = path.replace('town-name', 'online')

    return path
  }

  if (filtersStore.filters.visitLocation === 'home') {
    path = path.replace('town-name', commonStore.town.translit)
    path += 'na-dom/'

    return path
  }

  if (filtersStore.filters.place?.townRedirect) {
    path = path.replace('town-name', filtersStore.filters.place.townRedirect.translit)
  } else if (filtersStore.filters.place?.isMetro) {
    path = path.replace('town-name', commonStore.town.regionalCenter.translit)
  } else {
    path = path.replace('town-name', commonStore.town.translit)
  }

  if (filtersStore.filters.place && !filtersStore.filters.place?.townRedirect) {
    if (filtersStore.filters.place.isMetro) {
      path += `metro-${filtersStore.filters.place.translit}/`
    } else {
      path += `d-${filtersStore.filters.place.translit}/`
    }
  }

  return path
}

function generateSearch() {
  const filtersStore = useFiltersStore()
  const query = []

  if (filtersStore.filters.otherSpeciality) {
    query.push(`other_speciality=${filtersStore.filters.otherSpeciality.translit}`)
  }

  if (filtersStore.filters.disease) {
    query.push(`disease=${filtersStore.filters.disease.translit}`)
  }

  if (filtersStore.filters.city) {
    query.push(`town=${filtersStore.filters.city.translit}`)
  }

  if (filtersStore.filters.experience) {
    query.push(`experience=${filtersStore.filters.experience}`)
  }

  if (filtersStore.filters.gender) {
    query.push(`gender=${filtersStore.filters.gender}`)
  }

  if (filtersStore.filters.science) {
    query.push(`science=${filtersStore.filters.science}`)
  }

  if (filtersStore.filters.category) {
    query.push(`category=${filtersStore.filters.category}`)
  }

  if (filtersStore.filters.sort) {
    query.push(`sort=${filtersStore.filters.sort}`)
  }

  if (filtersStore.filters.dateRange) {
    const [startDate, endDate] = filtersStore.filters.dateRange

    query.push(`date_from=${startDate}`)
    query.push(`date_to=${endDate}`)
  }

  if (filtersStore.filters.timesOfDay) {
    query.push(`daytimes=${filtersStore.filters.timesOfDay.join(',')}`)
  }

  if (filtersStore.filters.patientAge !== undefined) {
    query.push(`patient_age=${filtersStore.filters.patientAge}`)
  }

  if (filtersStore.filters.price.from !== undefined) {
    query.push(`price_from=${filtersStore.filters.price.from}`)
  }

  if (filtersStore.filters.price.to !== undefined) {
    query.push(`price_to=${filtersStore.filters.price.to}`)
  }

  if (filtersStore.filters.isHighRating !== undefined) {
    query.push('high_rating=true')
  }

  if (filtersStore.filters.isOnlineAppointment !== undefined) {
    query.push('online_appointment=true')
  }

  if (filtersStore.filters.isClubAppointment !== undefined) {
    query.push('club_appointment=true')
  }

  return query.join('&')
}

export default getFiltersUrl
